import React, { useState } from "react";
import { useSelector } from "react-redux";
import TogglerBody from "../../TogglerBody";
// import InputCheckBoxUser from "../../InputCheckBoxUser";
import ChooseActionTamplate from "../../actionTamplate/ChooseActionTamplate";
import CounterTemplate from "./CounterTemplate";
import TipsTamplate from "../../TipsTamplate";
import SearchDropdown from "../../SearchDropdown/SearchDropdow";
import SearchDropdownBtn from "../../SearchDropdown/SearchDropdownBtn";
import { RxCross1 } from "react-icons/rx";
import {
  IoIosArrowUp,
  IoIosArrowDown,
  // IoIosArrowForward,
  // IoIosArrowBack,
} from "react-icons/io";
import "./statusTamplate.scss";
import { useChanges } from "../../../../hooks/useChanges";
import {statusActions} from '../../../../constants/common'

const StatusTemplateDomain = ({ currentId, data }) => {
  const { addChangeToStore } = useChanges();
  const [isOnMonitor, setIsOnMonitor] = useState(data?.data?.enabled);
  const [isOnPunish, setIsOnPunish] = useState(data?.data?.applyPunishment);
  const [isUseFilter, setIsUseFilter] = useState(data?.data?.useFilter);
  const [allowedDomains, setAllowedDomains] = useState(data?.data?.allowedDomains || []);  
  const [allowedChannels, setAllowedChannels] = useState(data?.data?.allowedChannels || []);
  const [currentAction, setCurrentAction] = useState(data?.data?.punishment || "Kick");
  const [counterWebhookQua, setCounterWebhookQua] = useState(data?.data?.quantityCreation || 5);
  const [inputValue, setInputValue] = useState("");
  const [inputValueChannels, setInputValueChannels] = useState("");
  const [showBtnChannels, setShowBtnChannels] = useState(true);
  const { channelsGlobalState } = useSelector((state) => state.channels);

  const addNewDomain = () => {
    const newDomain = {
      name: inputValue,
      id: allowedDomains.length + 1,
    };
    setAllowedDomains((prev) => [...prev, newDomain]);
    setInputValue("");
    addChangeToStore({ key: "allowedDomains", value: [...allowedDomains, newDomain] });
  };


  const handleKeyPressDomain = (e) => {
    if (inputValue && e.key === "Enter") {
      addNewDomain();
    }
  };
  
    const deleteDomain = (id) => {
    const updatedDomains = allowedDomains.filter((user, idx) => user.id !== id);
    setAllowedDomains(updatedDomains);
    addChangeToStore({ key: "allowedDomains", value: updatedDomains });
  };
  
  const addChannel = (obj) => {
    const channelExists = allowedChannels.some((channel) => channel.id === obj.id);
    if (!channelExists) {
      setAllowedChannels((prevChannels) => [...prevChannels, obj]);
      addChangeToStore({ key: "allowedChannels", value: [...allowedChannels, obj] });
    }
    setInputValueChannels("");
  };
  
    const deleteChannels = (id) => {
    const updatedChannels = allowedChannels.filter((user) => user.id !== id);
    setAllowedChannels(updatedChannels);
    addChangeToStore({ key: "allowedChannels", value: updatedChannels });
  };

  const quantityCreationHandler = (currentValue) => {
    addChangeToStore({ key: "quantityCreation", value: currentValue });
  }

  const incrementCounter = () => {
    const newValue = counterWebhookQua + 1;
    setCounterWebhookQua(newValue); 
    quantityCreationHandler(newValue);
}

const decrementCounter = () => {
    const newValue = counterWebhookQua - 1;
    setCounterWebhookQua(newValue); 
    quantityCreationHandler(newValue);
}

  return (
    <div className="status_block_wrap">
      <div className="status_block_wrap_bg"></div>
      <img
        className="status_block_wrap_img"
        src="/img/StatusBlock.svg"
        alt=""
      />
      <h3>Status</h3>
      <div
        className="status_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
          <p>Monitor Webhooks</p>
        </div>
      </div>
      <div
        className="status_block_item"
        style={{
          borderBottom: "1px solid #8D99A3",
          paddingBottom: "35px",
        }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={"applyPunishment"} />
          <p>Apply Punishment</p>
        </div>
        <ChooseActionTamplate
          keyName={"punishment"}
          currentAction={currentAction}
          setCurrentAction={setCurrentAction}
          actionArr={statusActions}
        />
      </div>
      <div className="status_block_item">
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isUseFilter} setIsOn={setIsUseFilter} keyName={"useFilter"} />
          <p>Use Filter</p>
        </div>
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Select Allowed Domains:</p>
          <TipsTamplate
            title={"Integrations Filter"}
            label={"Safe"}
            text={
              '<p>Utilise the "Allowed Domains" option to define domains authorised for web-hook communication. All other domains will be blacklisted and Themis will delete incoming information.</p>'
            }
            textSecond={"<p>Leave blank to blacklist all domains</p>"}
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {allowedDomains && allowedDomains.map((item, idx) => (
            <div
              key={idx}
              className="access_component_user_one white_list_block_user_one"
            >
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteDomain(item.id)}
              >
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyPress={handleKeyPressDomain}
          />
        </div>
      </div>
      <div className="status_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">
            Select Allowed Channels:
          </p>
          <TipsTamplate
            title={"Channels Filter"}
            label={"Unsafe"}
            text={
              "<p>Exclude specified channels from web-hook processing, while automatically blocking web-hooks originating from all other channels</p>"
            }
            textSecond={"<p>Leave blank to blacklist all channels</p>"}
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {allowedChannels && allowedChannels?.map((item, idx) => (
            <div
              key={idx}
              className="access_component_user_one white_list_block_user_one"
            >
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteChannels(item.id)}
              >
                <RxCross1 />
              </span>
            </div>
          ))}
          {showBtnChannels ? (
            <SearchDropdownBtn setShowBtn={setShowBtnChannels} />
          ) : (
            <SearchDropdown
              data={channelsGlobalState?.data?.channels}
              value={inputValueChannels}
              setInputValue={setInputValueChannels}
              setShowBtn={setShowBtnChannels}
              handleSelectItem={addChannel}
            />
          )}
        </div>
      </div>
      <div className="status_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Quantity Creation Flag:</p>
          <TipsTamplate
            title={"Quantity Creation Flag"}
            label={"Dangerous"}
            text={
              "<p>Define the number of web-hooks needed to trigger Themis`s protection mechanism.</p>"
            }
            textSecond={
              "<p>A member approximately needs to create <span> 5 </span> web-hooks before getting <span> Kick </span> .</p>"
            }
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap status_block_item_counter_wrap">
          <div className="status_block_item_counter">
            <div className="status_block_item_counter_webhook">
              <button
                onClick={incrementCounter}
              >
                <IoIosArrowUp />
              </button>
              <button
                onClick={decrementCounter}
              >
                <IoIosArrowDown />
              </button>
              <input
                type="text"
                value={counterWebhookQua}
                onChange={(e) => setCounterWebhookQua(e.target.value)}
              />
              <p>webhooks</p>
            </div>
          </div>
        </div>
      </div>
      <div className="status_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">
            Frequency Creation Flag:
          </p>
          <TipsTamplate
            title={"Frequency Creation Flag"}
            label={"Dangerous"}
            text={
              "<p>Define the frequency of web-hooks creation needed to trigger Themis`s  protection mechanism.</p>"
            }
            textSecond={
              "<p>A member approximately needs to create <span> 5 </span> web-hooks in <span> 1 </span> minute before getting  <span> Kick </span> .</p>"
            }
          />
        </div>
        <CounterTemplate
          data={data}
          keyName={"frequencyCreation"}
          keyTime={"frequencyPer"}
          valueTitle="webhooks"
          valueTime={"min"}
          timeType={"min"}
        />
      </div>
    </div>
  );
};

export default StatusTemplateDomain;
